import { FormattedMessage } from 'react-intl'

import Theme from '@theme'
import { Tip } from '@tribegroup'
import { SamplingCampaignHintWrapper } from './SamplingCampaignHint.styled'

export const SamplingCampaignHint = () => (
  <SamplingCampaignHintWrapper>
    <Tip
      width={20}
      icon={{
        padded: true,
        color: Theme.primaryColor,
        backgroundColor: Theme.primary200Color,
      }}
      text={
        <FormattedMessage
          id="socialSubmission.card.modal.approve.samplingCampaignWarning"
          values={{ span: (chunks) => <span className="title">{chunks}</span>, br: () => <br /> }}
        />
      }
    />
  </SamplingCampaignHintWrapper>
)

export default SamplingCampaignHint
